import { StepCategory } from '../../types/app_data';
import { isRefiQualified } from '../../utils/app_data';
import type { Step } from '../types/step';
import { ENABLE_REFI } from '../../utils/constants';

export const RefiOfferStep: Step = {
  id: 'refioffer',
  pathname: '/refioffer',
  canShow: (appData) => {
    if (!ENABLE_REFI) {
      return false;
    }

    // Don't ask if user is onboarding lite.
    if (appData.isOnboardingLite) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    // Don't ask if the user selected refi service or not selected insurance service.
    if (appData.serviceSplitSelectedService?.refi || !appData.serviceSplitSelectedService?.insurance) {
      return false;
    }

    // Only show if user is disqualified for refi and user has a car loan.
    return isRefiQualified(appData) && !!appData.signupParams?.hasCarLoan;
  },
  hasData: () => true,
  hasOwnData: () => true,
  category: () => StepCategory.Other,
};
